/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import { SettingsPagePlannerViewViewerFragmentDoc } from './SettingsPagePlannerView.generated';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type ChildrenStateAnswer =
  /** 子どもがいる */
  | 'HAS_CHILDREN'
  /** 子どもがいない */
  | 'HAS_NO_CHILDREN'
  /** 回答しない */
  | 'NO_ANSWER'
  /** 未回答 */
  | 'UNANSWERED';

export type Gender =
  | 'FEMALE'
  | 'MALE'
  | 'NO_ANSWER'
  | 'OTHER';

export type SettingsPagePlannerViewFetcherQueryVariables = Exact<{ [key: string]: never; }>;


export type SettingsPagePlannerViewFetcherQuery = { viewer: { hasLineActivationProvider: boolean, profile: { childrenState: { answer: Types.ChildrenStateAnswer, children: Array<{ birthday: DateString, gender: Types.Gender }> }, address: { postalCode: string, prefecture: string, city: string, town: string } | null } } };


export const SettingsPagePlannerViewFetcherDocument = gql`
    query SettingsPagePlannerViewFetcher {
  viewer {
    ...SettingsPagePlannerViewViewer
  }
}
    ${SettingsPagePlannerViewViewerFragmentDoc}`;

/**
 * __useSettingsPagePlannerViewFetcherQuery__
 *
 * To run a query within a Vue component, call `useSettingsPagePlannerViewFetcherQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettingsPagePlannerViewFetcherQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSettingsPagePlannerViewFetcherQuery();
 */
export function useSettingsPagePlannerViewFetcherQuery(options: VueApolloComposable.UseQueryOptions<SettingsPagePlannerViewFetcherQuery, SettingsPagePlannerViewFetcherQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SettingsPagePlannerViewFetcherQuery, SettingsPagePlannerViewFetcherQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SettingsPagePlannerViewFetcherQuery, SettingsPagePlannerViewFetcherQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SettingsPagePlannerViewFetcherQuery, SettingsPagePlannerViewFetcherQueryVariables>(SettingsPagePlannerViewFetcherDocument, {}, options);
}
export function useSettingsPagePlannerViewFetcherLazyQuery(options: VueApolloComposable.UseQueryOptions<SettingsPagePlannerViewFetcherQuery, SettingsPagePlannerViewFetcherQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SettingsPagePlannerViewFetcherQuery, SettingsPagePlannerViewFetcherQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SettingsPagePlannerViewFetcherQuery, SettingsPagePlannerViewFetcherQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SettingsPagePlannerViewFetcherQuery, SettingsPagePlannerViewFetcherQueryVariables>(SettingsPagePlannerViewFetcherDocument, {}, options);
}
export type SettingsPagePlannerViewFetcherQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SettingsPagePlannerViewFetcherQuery, SettingsPagePlannerViewFetcherQueryVariables>;